import { Deserializable } from "./deserializable"
import { MenuPermission } from "./menu-permission"

export class CheckUserVendorResponse implements Deserializable {
  userId?: string
  isVendor?: boolean
  isGateKeeper?: boolean
  vendorName?: string
  isVendorSuperAdmin?:boolean
  isVendorAdmin?:boolean
  isPlantRole?:boolean
  roles?: string[]
  menuPermisstion?:MenuPermission
  is_registration?:boolean
  is_reject_vendor?:boolean
  is_approve?:boolean
  is_vendor_auditor?:boolean
  is_vendor_reset?:boolean
  status?: string; // Add this line

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
}
}
